module.exports = __webpack_public_path__ + "static/media/SarahSwitek_04_BodySensations_23.abbb7e5b.mp3";